import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getGadgetMigrationStatus = (token, tenantId) => {
    return fetch(`${apiUrl}check_gadget_migration_status/${tenantId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });
}

export default getGadgetMigrationStatus
